module.exports = __webpack_public_path__ + "static/media/ampm_big.c73eba8a.jpg";